import { defineComponent as _defineComponent } from 'vue'
import { useTabs } from '~/composables';
import { computed } from 'vue';
import { useRoute } from '@nuxtjs/composition-api';

interface Props {
  navigation?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UiTabs',
  props: {
    navigation: { type: Boolean }
  },
  setup(__props: any, { expose }) {


const { tabs, activeTab, setActiveTab } = useTabs();
const route = useRoute();
const query = computed(() => route.value.query);

expose({
  tabs,
  activeTab,
  setActiveTab,
});

const tabLink = (link?: string) =>
  link && {
    path: link,
    query: {
      search: query.value.search,
    },
  };

return { __sfc: true,tabs, activeTab, setActiveTab, route, query, tabLink }
}

})